import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import image1 from './Image/Gallery-Banner.jpg';
import image2 from './Image/Bronze.jpg';

import { Pagination, Autoplay, EffectFade, Navigation } from 'swiper/modules';

// Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation'; // ✅ REQUIRED for arrows

const GalleryBanner = () => {
  return (
    <Swiper
      modules={[Pagination, Autoplay, EffectFade, Navigation]}
      spaceBetween={0}
      slidesPerView={1}
      effect="fade"
      autoplay={{
        delay: 2500,
        disableOnInteraction: false,
      }}
      pagination={{ clickable: true }}
      navigation={true} // ✅ arrows enabled
      loop={true}
      className="relative"
    >
      {/* Slide 1 */}
      <SwiperSlide>
        <div className="relative w-full">
          <img
            src={image1}
            alt="Gallery Banner"
            className="w-full h-full object-cover"
          />
        </div>
      </SwiperSlide>

      {/* Slide 2 */}
      <SwiperSlide>
        <div className="relative w-full">
          <img
            src={image2}
            alt="HIL 2026 Bronze Medal"
            className="w-full h-full object-cover"
          />
        </div>
      </SwiperSlide>
    </Swiper>
  );
};

export default GalleryBanner;